"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.concatPaths = concatPaths;
/**
 * Joins path segments into a dot-delimited path string.
 * Handles cleaning up multiple consecutive dots, leading dots, and trailing dots.
 *
 * @example
 * ```ts
 * concatPaths('users', 'profile', 'settings'); // returns 'users.profile.settings'
 * concatPaths('data.', '.config.', '3', 'value.'); // returns 'data.config.3.value'
 * ```
 */
function concatPaths(...paths) {
  return paths.join('.') // add . between each path
  .replace(/\.{2,}/g, '.') // replace .. with .
  .replace(/^\./, '') // remove leading .
  .replace(/\.$/, ''); // remove trailing .
}